import { Link, Text } from "@radix-ui/themes";
import { FC } from "react";

export const DataPrivacy: FC = () => {
  return (
    <>
      <Text as="p" weight={"bold"}>
        Glossar
      </Text>
      <Text as="p" weight={"bold"}>
        Standardvertragsklauseln
      </Text>
      <Text as="p">
        Standardvertragsklauseln ("Standard Contractual Clauses") sind von der
        EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen,
        dass Ihre Daten auch dann den europäischen Datenschutzstandards
        entsprechen, wenn diese in nicht europäische Drittländer überliefert und
        dort gespeichert bzw. verarbeitet werden. Durch diese Klauseln
        verpflichtet sich Google, bei der Verarbeitung Ihrer relevanten Daten,
        das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in
        den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln
        basieren auf einem Durchführungsbeschluss der EU-Kommission.
      </Text>
      <Text as="p">
        Das Glossar sollte ausgelagert werden, damit es die Datenschutzerklärung
        nicht noch länger macht, als notwendig.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Datenerfassung auf dieser Webseite
      </Text>
      <Text as="p" weight={"bold"}>
        Wer ist verantwortlich für die Datenerfassung auf dieser Webseite?
      </Text>
      <Text as="p">
        Die Datenverarbeitung auf dieser Website erfolgt durch den
        Websitebetreiber.
      </Text>
      <Text as="p">Alexander Bürkle GmbH & Co. KG</Text>
      <Text as="p">Robert-Bunsen-Str. 5</Text>
      <Text as="p">79108 Freiburg im Breisgau</Text>
      <Text as="p">Handelsregister: HRA 38</Text>
      <Text as="p">Registergericht: Amtsgericht Freiburg im Breisgau</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Wie erfassen wir Ihre Daten?
      </Text>
      <Text as="p">
        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
        mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein
        Kontaktformular eingeben.
      </Text>
      <Text as="p">
        Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch
        der Webseite durch unsere IT-Systeme erfasst. Das sind vor allem
        technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des
        Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald
        Sie diese Webseite betreten.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Wofür nutzen wir Ihre Daten?
      </Text>
      <Text as="p">
        Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der
        Webseite zu gewährleisten. Andere Daten können zur Analyse Ihres
        Nutzerverhaltens bzw. Surfverhaltens statistisch ausgewertet werden, um
        unsere Webseite zu verbessern oder den Komfort zu erhöhen. Wiederum
        andere, wie zum Beispiel in Formularen, werden verwendet, um Ihre
        Anfragen verarbeiten zu können oder eine Veranstaltungsanmeldung
        durchführen zu können.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Datenschutz
      </Text>
      <Text as="p" weight={"bold"}>
        Hinweis zur verantwortlichen Stelle
      </Text>
      <Text as="p">
        Die verantwortliche Stelle für die Datenverarbeitung auf dieser Webseite
        ist:
      </Text>
      <Text as="p">Alexander Bürkle GmbH & Co. KG</Text>
      <Text as="p">Robert-Bunsen-Str. 5</Text>
      <Text as="p">79108 Freiburg im Breisgau</Text>
      <Text as="p">Telefon: +49 761 5106-0</Text>
      <Text as="p">
        E-Mail:{" "}
        <Link href="mailto:info@alexander-buerkle.de">
          info@alexander-buerkle.de
        </Link>
      </Text>
      <Text as="p">
        Verantwortliche Stelle ist die natürliche oder juristische Person, die
        allein oder gemeinsam mit anderen über die Zwecke und Mittel der
        Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen
        o. Ä.) entscheidet.
      </Text>
      <Text as="p">
        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
        als Besucher und Nutzer unseres Webangebots sehr ernst. Wir behandeln
        Ihre personenbezogenen Daten vertraulich und entsprechend der
        gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
      </Text>
      <Text as="p">
        Wenn Sie diese Webseite benutzen, werden verschiedene personenbezogene
        Daten erhoben, sie sind somit ein sogenannter Betroffener.
        Personenbezogene Daten sind Daten, mit denen Sie persönlich
        identifiziert werden können. Die vorliegende Datenschutzerklärung
        erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie
        erläutert auch, wie und zu welchem Zweck das geschieht.
      </Text>
      <Text as="p">
        Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei
        der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
        lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
        möglich.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Gesetzlich vorgeschriebener Datenschutzbeauftragter
      </Text>
      <Text as="p">
        Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.
      </Text>
      <Text as="p">Alexander Bürkle GmbH & Co. KG</Text>
      <Text as="p">z.H. Datenschutzbeauftragter</Text>
      <Text as="p">Robert-Bunsen-Str. 5</Text>
      <Text as="p">79108 Freiburg im Breisgau</Text>
      <Text as="p">Telefon: +49 761 5106-0</Text>
      <Text as="p">
        E-Mail:{" "}
        <Link href="mailto:datenschutz@alexander-buerkle.de">
          datenschutz@alexander-buerkle.de
        </Link>
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Speicherdauer
      </Text>
      <Text as="p">
        Soweit innerhalb dieser Datenschutzerklärung keine speziellere
        Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei
        uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
        berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur
        Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir
        keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
        personenbezogenen Daten haben.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Status-Überwachung von Angeboten
      </Text>
      <Text as="p">
        Aufgrund unserer Prozesse werden Angebote, die von Kunden in unserem
        Onlineshop angefragt werden, automatisiert überwacht und ein
        entsprechender Status gesetzt. Dies ermöglicht uns eine ordentliche und
        effiziente Verarbeitung unserer Anfragen im Onlineshop. So können wir
        gewährleisten, dass unsere Kunden eine schnellstmögliche Information
        erhalten.
      </Text>
      <Text as="p">
        Diese Status-Überwachung speichert keine Cookies, sondern wird in einem
        sog. Local Storage vorgehalten.
      </Text>
      <Text as="p">
        Weitere Informationen zu Local Storages finden Sie in unserer
        Datenschutzerklärung.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Ihre Rechte als Betroffene
      </Text>
      <Text as="p" weight={"bold"}>
        Widerruf Ihrer Einwilligung zur Datenverarbeitung
      </Text>
      <Text as="p">
        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
        Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
        jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
        Datenverarbeitung bleibt vom Widerruf unberührt.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
      </Text>
      <Text as="p" weight={"bold"}>
        gegen Direktwerbung (Art. 21 DSGVO)
      </Text>
      <Text as="p">
        Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1. Lit. DSGVO
        erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, gegen die Verarbeitung ihrer
        personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein
        auf diese Bestimmungen gestütztes Profiling. Die jeweilige
        Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen Sie
        dieser Datenschutzerklärung.
      </Text>
      <Text as="p">
        Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu
        betreiben, so haben Sie das Recht, jederzeit Widerspruch gegen die
        Verarbeitung Sie betreffender personenbezogener Daten zum Zwecke
        derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit
        es mit solcher Direktwerbung in Verbindung steht. Wenn Sie
        widersprechen, werden Ihre personenbezogenen Daten anschließend nicht
        mehr zum Zwecke der Direktwerbung verwendet.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Beschwerderecht bei der zuständigen Aufsichtsbehörde
      </Text>
      <Text as="p">
        Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
        Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
        Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder
        des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht
        unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher
        Rechtsbehelfe.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Recht auf Datenübertragbarkeit
      </Text>
      <Text as="p">
        Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
        oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder
        an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen
        zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen
        Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
        machbar ist.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        SSL- bzw. TLS-Verschlüsselung
      </Text>
      <Text as="p">
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die
        Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
        TLS-Verschlüsselung.
      </Text>
      <Text as="p" weight={"bold"}>
        Auskunft, Löschung und Berichtigung
      </Text>
      <Text as="p">
        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
        das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
        personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
        Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung
        dieser Daten.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Recht auf Einschränkung der Verarbeitung
      </Text>
      <Text as="p">
        Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Wie erteilen Sie uns Ihre Einwilligung zu Cookies?
      </Text>
      <Text as="p" weight={"bold"}>
        Usercentrics
      </Text>
      <Text as="p">
        Diese Webseite nutzt die Cookie-Consent-Technologie von Usercentrics, um
        Ihre Einwilligung zur Speicherung bestimmter Cookies auf Ihrem Endgerät
        oder zum Einsatz bestimmter Technologien einzuholen und diese
        datenschutzkonform zu dokumentieren. Anbieter dieser Technologie ist die
        Usercentrics GmbH.
      </Text>
      <Text as="p">Usercentrics GmbH</Text>
      <Text as="p">Rosental 4</Text>
      <Text as="p">80331 München</Text>
      <Text as="p">Deutschland</Text>
      <Text as="p">
        Wenn Sie unsere Webseite betreten, werden folgende personenbezogene
        Daten an Usercentrics übertragen:
      </Text>
      <Text as="p">
        • Ihre Einwilligung(en) bzw. der Widerruf Ihrer Einwilligung(en)
      </Text>
      <Text as="p">• Ihre IP-Adresse</Text>
      <Text as="p">• Informationen über Ihren Browser</Text>
      <Text as="p">• Informationen über Ihr Endgerät</Text>
      <Text as="p">• Zeitpunkt Ihres Besuchs auf der Webseite</Text>
      <Text as="p">
        Des Weiteren speichert Usercentrics ein Cookie in Ihrem Browser, um
        Ihnen die erteilten Einwilligungen bzw. deren Widerruf zuordnen zu
        können.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Vertrag zur Auftragsdatenverarbeitung
      </Text>
      <Text as="p">
        Um die datenschutzkonforme Verarbeitung zu gewährleisten, haben wir
        einen Vertrag für die Auftragsverarbeitung mit der Usercentrics GmbH
        geschlossen.
      </Text>
      <Text as="p" weight={"bold"}>
        Cookie-Einstellungen ändern
      </Text>
      <Text as="p">
        Sie können Ihre Einstellungen für Cookies, die Sie beim Aufruf der
        Webseite getroffen haben, jederzeit ändern. Klicken Sie bitte auf den
        nachfolgenden Link:
      </Text>
      <Text as="p">
        <Link
          href="https://web.alexander-buerkle.com/de/rechtliches/datenschutz"
          target="_blank"
        >
          Cookie-Einstellungen anpassen
        </Link>
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Microsoft Azure Cloud (Hosting)
      </Text>
      <Text as="p">
        Auf unserer Webseite wird ein Webservice des Unternehmens Microsoft
        Corporation (nachfolgend "Microsoft Azure") nachgeladen. Anbieter des
        Webservices ist die Microsoft Corporation.
      </Text>
      <Text as="p">Microsoft Corporation</Text>
      <Text as="p">One Microsoft Way</Text>
      <Text as="p">98052-6399 Redmond WA</Text>
      <Text as="p">USA</Text>
      <Text as="p">
        Wir nutzen diese Daten, um die volle Funktionalität unserer Webseite zu
        gewährleisten. In diesem Zusammenhang wird Ihr Browser ggf.
        personenbezogene Daten an Microsoft Azure übermitteln.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Cloudflare
      </Text>
      <Text as="p">
        Wir nutzen den Service „Cloudflare“. Cloudflare bietet ein weltweit
        verteiltes Content Delivery Network mit DNS (Domain Name Server) an.
        Dabei wird technisch der Informationstransfer zwischen Ihrem Browser und
        unserer Webseite über das Netzwerk von Cloudflare geleitet.
      </Text>
      <Text as="p">Cloudflare Inc.</Text>
      <Text as="p">101 Townsend St.</Text>
      <Text as="p">San Francisco, CA 94107</Text>
      <Text as="p">USA</Text>
      <br />
      <Text as="p" weight={"bold"}>
        Vertrag zur Auftragsdatenverarbeitung
      </Text>
      <Text as="p">
        Um die datenschutzkonforme Verarbeitung zu gewährleisten, haben wir im
        Rahmen des Hauptvertrags einen DPA („Data Processing Agreement") für die
        Auftragsverarbeitung mit der Cloudflare Inc. geschlossen.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Local Storages (Lokaler Code)
      </Text>
      <Text as="p">
        Der „Local Storage" ist ein Speicherformat-Typ in der Web-Umgebung. Er
        ermöglicht es, Daten auf dem Endgerät des Benutzers zu speichern, die
        kein Ablaufdatum besitzen.
      </Text>
      <Text as="p">
        Von uns eingesetzte Dienste, die Local Storages nutzen:
      </Text>
      <Text as="p">
        • Alexander Bürkle (Alexander Bürkle GmbH & Co. KG, Robert-Bunsen-Str.
        5, 79108 Freiburg im Breisgau)
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Salesmanago; Newsletter
      </Text>
      <Text as="p">
        Auf unserer Webseite verwenden wir den Dienst „Salesmanago“. Bei diesem
        Dienst handelt es sich um einen Marketing-Automatisierungsdienst der zur
        Erstellung personalisierter E-Mails (Newsletter) und zur Analyse des
        Nutzerverhaltens Cookies verwendet.
      </Text>
      <Text as="p">Anbieter ist die Benhauer Sp. Z O.O. (POLAND)</Text>
      <Text as="p">Benhauer Sp. Z O.O.</Text>
      <Text as="p">21 Grzegórzecka St. 31-532</Text>
      <Text as="p">Krakau</Text>
      <Text as="p">Polen</Text>
      <Text as="p">
        Diese Wiedererkennungsmöglichkeit wird verwendet, um Nutzerprofile zu
        erstellen und anschließend dem jeweiligen Nutzer personalisierte Werbung
        zur Verfügung zu stellen.
      </Text>
      <Text as="p">
        Weitere Informationen zu den Datenschutzbestimmungen des Verarbeiters
        und dessen Cookie-Richtlinie finden Sie unter den Terms and Conditions:
      </Text>
      <Text as="p">
        <Link
          href="https://www.salesmanago.com/marketing-automation/terms.htm"
          target="_blank"
        >
          https://www.salesmanago.com/marketing-automation/terms.htm
        </Link>
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Vertrag zur Auftragsdatenverarbeitung
      </Text>
      <Text as="p">
        Um die datenschutzkonforme Verarbeitung zu gewährleisten, haben wir
        einen Vertrag für die Auftragsverarbeitung mit der Benhauer Sp. Z O. O.
        geschlossen.
      </Text>
      <Text as="p" weight={"bold"}>
        Lieferstatus & Sendungsverfolgung per DHL
      </Text>
      <Text as="p">
        Wir bieten auf unserer Website eine Funktion zur Abfrage Ihres Auftrags-
        und Lieferstatus an. Für die Sendungsverfolgung werden die von Ihnen
        eingegebene Kundennummer und Auftragsnummer über eine Schnittstelle an
        DHL übermittelt und dort verarbeitet, um den aktuellen Lieferstatus zu
        ermitteln und zur Anzeige auf unserer Website zurückzugeben.
      </Text>
      <Text as="p">
        Die Verarbeitung erfolgt zur Erfüllung des Vertrags (Art. 6 Abs. 1 lit.
        b DSGVO).
      </Text>
      <Text as="p">
        Weitere Informationen zur Datenverarbeitung durch DHL finden Sie in den
        Datenschutzhinweisen von DHL.
      </Text>
      <br />
      <Text as="p" weight={"bold"}>
        Lieferstatus & Sendungsverfolgung per DPD
      </Text>
      <Text as="p">
        Wir stellen auf unserer Website eine Möglichkeit bereit, den Auftrags-
        und Lieferstatus einzusehen. Wenn Sie die Sendungsverfolgung nutzen,
        werden die von Ihnen angegebenen Kundennummer und Auftragsnummer über
        eine technische Schnittstelle an DPD übermittelt.
      </Text>
      <Text as="p">
        Die Verarbeitung erfolgt zur Erfüllung des Vertrags (Art. 6 Abs. 1 lit.
        b DSGVO).
      </Text>
      <Text as="p">
        Weitere Informationen zur Datenverarbeitung durch DPD finden Sie in den
        Datenschutzhinweisen von DPD.
      </Text>
    </>
  );
};
